import React from 'react';
import { FormGroup, Alert } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../../../helpers/formGroupVariants';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import ModalWrapper from '../../../helpers/modalWrapper';
import ColumnButtons from '../../../helpers/columnButtons';
import { SIZE_MD, ERROR } from '../../../helpers/constants';
import { filterFirmsByAragProvider, formatSolicitorOptionLabel, isAgentOutsideAragProvider } from '../../../helpers/functions';

const NewCommissionModal = (props) => {
    const {
        isOpen,
        onClose,
        onSuggestionChange,
        onSuggestionSelected,
        submitHandler,
        solicitorsList,
        lawsysFirms,
        // The ARAG provider of the solicitor group the premium setting is written for. Null/undefined
        // when there is none to be consistent with (a group that predates provider ownership, or the
        // staged/application flows that do not carry one) and then nothing is filtered out.
        solicitorGroupAragProviderId,
        modalTestId,
        formGroupLabelTestId,
        formGroupInputTestId,
        buttonTestId,
        linkTestId,
    } = props;

    const selectedFirm = lawsysFirms.selectedLawsysFirmsDropdown.length > 0
        ? lawsysFirms.selectedLawsysFirmsDropdown[0]
        : null;
    const commissionValue = selectedFirm
        ? {value: selectedFirm.id, label: selectedFirm.name, aragProvider: selectedFirm.aragProvider}
        : null;
    // Only agents of the group's own ARAG provider are offered, so a mismatching one cannot be picked
    // from the dropdown in the first place.
    const commissionOptions = filterFirmsByAragProvider(lawsysFirms.lawsysFirmsFiltered, solicitorGroupAragProviderId)
        .filter(x => solicitorsList.some(s => s.id === x.id) === false)
        .map(l => ({value: l.id, label: l.name, aragProvider: l.aragProvider}));
    // Belt and braces for whatever the dropdown did not have to decide - a firm carried over in the
    // store from an earlier search, say. Blocks the add rather than leaving the server to reject the
    // whole save several steps later.
    const hasAragProviderMismatch = isAgentOutsideAragProvider(selectedFirm, solicitorGroupAragProviderId);

    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            modalTestId={modalTestId}
            size={SIZE_MD}
        >
            <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                <FormGroup
                    labelSize={"col-sm-3"}
                    inputSize={"col-sm-7"}
                    label={CONTENT_STRINGS.AGENT}
                    variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
                    inputProps={{
                        id: 'agentSelect',
                        name: 'agentSelect',
                        inputValue: lawsysFirms.suggestionFieldValue,
                        onInputChange: onSuggestionChange,
                        instanceId: 'agent',
                        value: commissionValue,
                        onChange: (value) => onSuggestionSelected(value),
                        options: commissionOptions,
                        isLoading: lawsysFirms.fetching,
                        placeholder: CONTENT_STRINGS.TYPE_AT_LEAST_3_LETTERS,
                        noOptionsText: CONTENT_STRINGS.NO_AGENTS_FOUND,
                        minSearchCharacters: 3,
                        isMulti: false,
                        formatOptionLabel: formatSolicitorOptionLabel,
                    }}
                    labelTestId={formGroupLabelTestId}
                    inputTestId={formGroupInputTestId}
                />
                {
                    hasAragProviderMismatch
                        ? <Alert variant={ERROR} label={CONTENT_STRINGS.COMMISSION_AGENT_ARAG_PROVIDER_MISMATCH} />
                        : null
                }
                <ColumnButtons
                    buttonLabel={CONTENT_STRINGS.ADD_TO_COMMISSION_LIST}
                    submitHandler={submitHandler}
                    linkLabel={CONTENT_STRINGS.CANCEL}
                    linkTestId={linkTestId}
                    discardHandler={onClose}
                    buttonTestId={buttonTestId}
                    isButtonDisabled={lawsysFirms.selectedLawsysFirmsDropdown.length === 0 || hasAragProviderMismatch}
                />
            </div>
        </ModalWrapper>
    );
};

export default NewCommissionModal;
